import { TypographyColor } from 'melp-design/components';
import {
  EmployeeCognitoStatus,
  EmployeeStatus,
  EmploymentStatus,
} from './employees.types';

export const COLOR_BY_EMPLOYEE_STATUS: Record<EmployeeStatus, TypographyColor> =
  {
    active: 'success',
    inactive: 'textSecondary',
  };

export const COLOR_BY_EMPLOYMENT_STATUS: Record<
  EmploymentStatus,
  TypographyColor
> = {
  active: 'success',
  ended: 'textSecondary',
  endsSoon: 'warning',
  inactive: 'textSecondary',
  recentlyEnded: 'warning',
};

export const MASKED_EMPLOYEE_PLACEHOLDER = '********';

export const COGNITO_CHIP_VARIANT: Record<
  EmployeeCognitoStatus,
  'success' | 'warning' | 'neutral'
> = {
  linked: 'success',
  missing: 'warning',
  unlinked: 'neutral',
  unavailable: 'neutral',
};
